import { render, staticRenderFns } from "./PathDetail.vue?vue&type=template&id=1d8ed624"
import script from "./PathDetail.vue?vue&type=script&lang=js"
export * from "./PathDetail.vue?vue&type=script&lang=js"
import style0 from "./PathDetail.vue?vue&type=style&index=0&id=1d8ed624&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports